<template>
    <div class="mx-md-5 my-4">
        <div class="container-fluid w-100">
            <div class="notification-list mb-2">
                <button class="btn btn-primary shadow btnl" @click="addRole">
                    <i class="fas fa-solid fa-plus"></i>Nouveau rôle
                </button><br>
            </div>
            <div class="pt-5 d-md-flex w-100 flex-wrap">
                <div class="mr-md-auto mt-2">
                    <h2 class="default fwb">Liste des roles</h2><br>
                </div>
            </div>
            <div class="">
                <div class="bg-transparent d-none d-md-block">
                    <div class="rounded taille mb--3 align-items-center">
                        <ul
                            class="list-none px-2 py-2 row-lg table-header gap-2 justify-content-between d-flex align-items-center">
                            <!-- <li class="col-lg ml-2"><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->
                            <li class="col-lg nom">Noms</li>
                            <li class="col-lg nom">nombre d'utilisateurs</li>
                            <!-- <li class="col-lg d-none d-lg-block">Permissions</li> -->
                            <li class="col-lg d-none d-lg-block">Actions</li>
                        </ul>
                    </div>
                    <!-- <div class="row justify-content-center my-4 pr-2" role="status"
                        v-if="!rdvfromteleconsultations.data.data">
                        <div class="loading"></div>
                    </div> -->
                    <!-- @mouseleave="mouse = false" @mouseover="mouse = true" :class="mouse? 'col-md cursor-pointer hoverTd':'col-md cursor-pointer'" -->
                    <div :class="mouse ? 'rounded mb-1 align-items-center cursor hoverTd' : 'rounded bg-white mb-1 align-items-center cursor'" @mouseleave="mouse = false" @mouseover="mouse = true" v-for="item in roles" :key="item.id">
                        <div @click="voirRole(item.id)">
                            <ul class="list-none d-flex row-lg default fwn px-2 py-3 mb-2 gap-2 justify-content-between align-items-center"
                                id="modalTC">
                                <!--  card-active <li class="col-lg "><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->
                                <li class="col-lg d-flex align-items-center gap-1">
                                    <!-- <i class="fas fa-circle text-primary text-i"></i> -->
                                    <span class="m-0 fwb">{{ item.name }}</span>
                                </li>
                                <li class="col-lg d-flex align-items-center gap-1">
                                    <span class="m-0 fwb">{{ item.users_count }}</span>
                                </li>
                                <li class="col-lg d-flex align-items-center">
                                    <span size="sm" class="border-right text-primary cursor border-5 pr-2" @click="voirRole(item.id)">
                                        <!-- <svg viewBox="64 64 896 896" focusable="false" data-icon="edit" width="1.2em" height="1.2em" fill="currentColor" aria-hidden="true"><path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path></svg> -->
                                        <span class="voir-role"><i class="fa fa-eye mr-1"></i>voir</span>
                                    </span> <!-- @click="openModalShow(item.uuid)" -->
                                    <span class="cursor" size="sm">
                                        <i @click="DeleteRole(item)" class="fa fa-trash colorGrey px-2" aria-hidden="true"></i>
                                        <!-- <i @click="getAlerte(item)" class="fas fa-edit"></i> -->
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <ModalRole :modal_id="'modal-xl-' + item.id" :role="item"/>
                        
                    </div>
                    <DeleteRole id="delete-modal" :item="item"/>
                    <!-- <ModalAlerte modal_id="modal" :alerte="{}"  @clickClose="$bvModal.hide('modal')"/>
                    <ModalDeleteAlerte id="delete-modal" :item="item"/> -->
                </div>
            </div>
            

            <b-modal hide-footer
                id="modal-prevent-closing"
                ref="modal"
                @show="resetModal"
                @hidden="resetModal"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :header-title-variant="headerTextVariant"
            >
                <template v-slot:modal-header>
                    <h5 class="modal-title text-white">
                        <b>Nouveau rôle</b>
                    </h5>
                </template>
                    <form ref="form" @submit.stop.prevent="handleSubmit" id="form">
                        <b-form-group
                        label="Nom"
                        label-for="name-input"
                        invalid-feedback="Le nom est requis"
                        :state="roleState"
                        >
                            <b-form-input
                                id="name-input"
                                v-model="name"
                                :state="roleState"
                                required
                            ></b-form-input>
                        </b-form-group>
                        <div class="text-center">
                            <b-button variant="success"  class="mt-3" @click="handleSubmit">Soumettre</b-button>
                            <b-button variant="danger" class="mt-3" @click="closeModal">Modifier</b-button>
                        </div>
                    </form>
            </b-modal>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import router from '../../router/router';
import { mapGetters, mapState } from "vuex";
import Multiselect from 'vue-multiselect';
import ModalRole from "./ModalRole.vue";
import DeleteRole from "./DeleteRole.vue";
export default {
    name: "MoreAppointments",

    components: {
        Multiselect,
        ModalRole,
        DeleteRole
    },
    computed: {
        ...mapGetters(["roles","permissions",'hasAdminRole']),
    },

    data() {
        return {
            mouse:false,
            name: '',
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            load: true,
            moreDetails: true,
            loading: false,
            role: {},
            item: {},
            Home: false,
            mobileView: true,
            search: "",
            roleState: null,
            submittedNames: []
        }
    },

    methods: {
        addRole() {
            this.$nextTick(() => {
                this.$bvModal.show('modal-prevent-closing')
            })
        },
        closeModal() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },
        getRoles() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getRoles", {  args: args });
        },
        getPermissions() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getPermissions", { args: args });
        },
        voirRole(id) {
             router.push({ name: 'view-role-details', params: { id: id } });
        },

        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.roleState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.roleState = null
        },
        DeleteRole(item) {
            // console.log(item);
            this.item = item;
            this.$bvModal.show("delete-modal");
        },
        // handleOk(bvModalEvent) {
        //     // Prevent modal from closing
        //     bvModalEvent.preventDefault()
        //     // Trigger submit handler
        //     this.handleSubmit()
        // },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                console.log(this.name);
                return
            }
            // console.log(this.name);
            let args = {
                name: this.name,
            }
            // console.log(args);
            let successMessage = this.$i18n.t('message.RoleCreated');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };

            this.$store.dispatch('createRole', { args, errorMessages, successMessage })
            .then(() => {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }

    },
    mounted() {
        this.getRoles();
        // this.getPermissions();
    },
}
</script>
<style lang="scss">
.hoverTd:hover{
    background-color: #2dcecc;
    li{
    color: white;}
    span{
        color: white;
    }
    .voir-role{
        color: white;
    }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>